import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    getPremiumPaperCategories
} from "../config/userApi";

import "./PremiumMCQ.css";


function PrimePaperCategory() {

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | STATE
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    const [
        name,
        setName
    ] = useState(
        Cookies.get("username") || "Student"
    );


    const [
        categories,
        setCategories
    ] = useState([]);


    const [
        loading,
        setLoading
    ] = useState(true);


    const [
        error,
        setError
    ] = useState("");


    /*
    |--------------------------------------------------------------------------
    | LOAD USER + PREMIUM PAPER CATEGORIES
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        let mounted = true;


        const loadPremiumPaperCategories = async () => {

            try {

                setLoading(true);

                setError("");


                /*
                |--------------------------------------------------------------------------
                | CHECK USER LOGIN
                |--------------------------------------------------------------------------
                */

                const meResponse =
                    await userMe();


                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                /*
                |--------------------------------------------------------------------------
                | USER NOT LOGGED IN
                |--------------------------------------------------------------------------
                */

                if (
                    meResponse.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | USER RESPONSE
                |--------------------------------------------------------------------------
                */

                const meResult =
                    await meResponse.json();


                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (!meResponse.ok) {

                    throw new Error(
                        meResult?.message ||
                        "Unable to verify user."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | SET USER NAME
                |--------------------------------------------------------------------------
                */

                if (
                    meResult?.user
                ) {

                    const username =
                        meResult.user.fullname ||
                        meResult.user.name ||
                        meResult.user.username ||
                        "Student";


                    if (mounted) {

                        setName(
                            username
                        );


                        Cookies.set(
                            "username",
                            username
                        );

                    }
                }


                /*
                |--------------------------------------------------------------------------
                | GET PREMIUM PAPER CATEGORIES
                |--------------------------------------------------------------------------
                */

                const response =
                    await getPremiumPaperCategories();


                console.log(
                    "PREMIUM PAPER CATEGORY STATUS:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | UNAUTHORIZED
                |--------------------------------------------------------------------------
                */

                if (
                    response.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | API RESPONSE
                |--------------------------------------------------------------------------
                */

                const result =
                    await response.json();


                console.log(
                    "PREMIUM PAPER CATEGORY RESPONSE:",
                    result
                );


                if (!response.ok) {

                    throw new Error(
                        result?.message ||
                        "Unable to fetch premium paper categories."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | SET CATEGORIES
                |--------------------------------------------------------------------------
                */

                if (mounted) {

                    setCategories(
                        Array.isArray(
                            result?.data
                        )
                            ? result.data
                            : []
                    );

                }

            } catch (err) {

                console.error(
                    "PREMIUM PAPER CATEGORY ERROR:",
                    err
                );


                if (mounted) {

                    setError(
                        err?.message ||
                        "Unable to connect with server."
                    );

                }

            } finally {

                if (mounted) {
                    setLoading(false);
                }

            }

        };


        loadPremiumPaperCategories();


        return () => {

            mounted = false;

        };

    }, [navigate]);


    /*
    |--------------------------------------------------------------------------
    | OPEN PAPER LIST
    |--------------------------------------------------------------------------
    |
    | IMPORTANT:
    |
    | Category click will go to:
    |
    | /prime-papers/:category
    |
    | Example:
    |
    | /prime-papers/ENT
    |
    */

    const openCategory = (
        category
    ) => {

        if (!category) {
            return;
        }


        navigate(
            `/prime-papers/${encodeURIComponent(
                category
            )}`
        );

    };


    /*
    |--------------------------------------------------------------------------
    | LOADING
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="user-dashboard">


                {/* =========================================================
                    SIDEBAR
                ========================================================= */}

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                {/* =========================================================
                    MAIN
                ========================================================= */}

                <main className="dashboard-main">


                    {/* HEADER */}

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    {/* LOADING */}

                    <div className="premium-mcq-loading">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                        >

                            <span className="visually-hidden">
                                Loading...
                            </span>

                        </div>


                        <p className="mt-3">
                            Loading Premium Papers...
                        </p>

                    </div>

                </main>

            </div>

        );
    }


    /*
    |--------------------------------------------------------------------------
    | MAIN UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard premium-mcq-page">


            {/* =========================================================
                SIDEBAR
            ========================================================= */}

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            {/* =========================================================
                MAIN
            ========================================================= */}

            <main className="dashboard-main">


                {/* =========================================================
                    HEADER
                ========================================================= */}

                <UserHeader
                    name={name}
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                {/* =========================================================
                    CONTENT
                ========================================================= */}

                <div className="dashboard-content">


                    {/* =====================================================
                        PREMIUM HEADER
                    ===================================================== */}

                    <section className="premium-mcq-header">


                        <div className="premium-header-content">


                            <span className="premium-mcq-badge">

                                <i className="bi bi-journal-medical"></i>

                                PREMIUM PAPERS

                            </span>


                            <h1>
                                Premium Paper Practice
                            </h1>


                            <p>
                                Select a category to view
                                your premium papers.
                            </p>

                        </div>


                        <div className="premium-header-icon">

                            <i className="bi bi-journal-medical"></i>

                        </div>

                    </section>


                    {/* =====================================================
                        ERROR
                    ===================================================== */}

                    {error && (

                        <div className="alert alert-danger mt-4">

                            <i className="bi bi-exclamation-triangle-fill me-2"></i>

                            {error}

                        </div>

                    )}


                    {/* =====================================================
                        NO CATEGORIES
                    ===================================================== */}

                    {!error &&
                        categories.length === 0 && (

                            <div className="premium-lock-card">


                                <div className="premium-lock-icon">

                                    <i className="bi bi-journal-x"></i>

                                </div>


                                <span className="locked-label">

                                    PREMIUM PAPERS

                                </span>


                                <h2>
                                    No Premium Paper Categories
                                </h2>


                                <p>
                                    You don't have any premium
                                    paper category available right now.
                                </p>


                                <p className="text-muted">

                                    Purchase a premium paper package
                                    to access premium papers.

                                </p>

                            </div>

                        )
                    }


                    {/* =====================================================
                        CATEGORIES
                    ===================================================== */}

                    {!error &&
                        categories.length > 0 && (

                            <section className="premium-subjects-wrapper">


                                {/* =================================================
                                    SECTION HEADER
                                ================================================= */}

                                <div className="premium-section-header mb-4">


                                    <div className="subject-title-wrapper">


                                        <div className="subject-icon">

                                            <i className="bi bi-journal-medical"></i>

                                        </div>


                                        <div>

                                            <h2>
                                                Select Category
                                            </h2>


                                            <p>
                                                Choose a category
                                                to view available papers.
                                            </p>

                                        </div>

                                    </div>


                                    <span className="premium-pro-badge">

                                        <i className="bi bi-gem"></i>

                                        PRO

                                    </span>

                                </div>


                                {/* =================================================
                                    CATEGORY CARDS
                                ================================================= */}

                                <div className="row g-4">


                                    {categories.map(
                                        (
                                            category,
                                            index
                                        ) => (

                                            <div
                                                className="col-xl-4 col-lg-6 col-md-6"
                                                key={
                                                    category.category ||
                                                    index
                                                }
                                            >


                                                <div
                                                    className="premium-paper-card premium-subject-card"
                                                    onClick={() =>
                                                        openCategory(
                                                            category.category
                                                        )
                                                    }
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(event) => {

                                                        if (
                                                            event.key === "Enter" ||
                                                            event.key === " "
                                                        ) {

                                                            event.preventDefault();

                                                            openCategory(
                                                                category.category
                                                            );

                                                        }

                                                    }}
                                                >


                                                    {/* =================================================
                                                        CARD TOP
                                                    ================================================= */}

                                                    <div className="paper-card-top">


                                                        <div className="premium-paper-number">

                                                            {String(
                                                                index + 1
                                                            ).padStart(
                                                                2,
                                                                "0"
                                                            )}

                                                        </div>


                                                        <span className="premium-card-badge">

                                                            <i className="bi bi-gem"></i>

                                                            PRO

                                                        </span>

                                                    </div>


                                                    {/* =================================================
                                                        CATEGORY ICON
                                                    ================================================= */}

                                                    <div className="premium-paper-icon">

                                                        <i className="bi bi-journal-medical"></i>

                                                    </div>


                                                    {/* =================================================
                                                        CATEGORY NAME
                                                    ================================================= */}

                                                    <h3>
                                                        {
                                                            category.category
                                                        }
                                                    </h3>


                                                    {/* =================================================
                                                        PAPER COUNT
                                                    ================================================= */}

                                                    <div className="premium-question-info">


                                                        <div className="question-icon">

                                                            <i className="bi bi-journal-text"></i>

                                                        </div>


                                                        <div>

                                                            <strong>
                                                                {
                                                                    category.total_papers ||
                                                                    0
                                                                }
                                                            </strong>


                                                            <span>

                                                                {(
                                                                    category.total_papers ||
                                                                    0
                                                                ) === 1
                                                                    ? "Paper"
                                                                    : "Papers"
                                                                }

                                                            </span>

                                                        </div>

                                                    </div>


                                                    {/* =================================================
                                                        VIEW PAPERS BUTTON
                                                    ================================================= */}

                                                    <button
                                                        type="button"
                                                        className="premium-action-btn"
                                                        onClick={(event) => {

                                                            event.stopPropagation();

                                                            openCategory(
                                                                category.category
                                                            );

                                                        }}
                                                    >

                                                        <span>
                                                            View Papers
                                                        </span>


                                                        <i className="bi bi-arrow-right"></i>

                                                    </button>

                                                </div>

                                            </div>

                                        )
                                    )}

                                </div>

                            </section>

                        )
                    }

                </div>

            </main>

        </div>

    );

}


export default PrimePaperCategory;